(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tt/assets/javascripts/models/tt-filter-model.js') >= 0) return;  svs.modules.push('/modules/tt/assets/javascripts/models/tt-filter-model.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.tt.models.TTFilter = Backbone.Model.extend({
    defaults: function() {
      this.set('availableSports', []);
      this.set('filters', {});
    },

    initialize: function() {
      var self = this;
      svs.tt.app.radio.on('availableSportsUpdated', function(newSports) {
        self.set('availableSports', _.sortBy(newSports, 'name'));
      });
    },

    newProductSelected: function(productSetting) {
      this.set('filters', {});
      this.set('productSetting', productSetting);

      svs.tt.app.radio.trigger('filtersApplied', {});
    }
  });
})(Backbone, _, svs);


 })(window);